// Shared constants for modal content components

import {spacing} from "@khanacademy/wonder-blocks-tokens";

export const PREVIEW_HEIGHT = 240;
export const PREVIEW_WIDTH = 320;
export const PADDING_TO_REVEAL_BORDER = spacing.xxxSmall_4;
